import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';

import { AuthenticationService } from '../services';

// Checks whether the user is authenticated (signed in). If not the
// user is redirected to the sign-in url
@Injectable({
  providedIn: 'root'
})
export class IsAuthenticatedGuard  {

  constructor(private authenticationService: AuthenticationService,
              private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authenticationService.isSignedIn().pipe(
      map(isSignedIn => {
        if (!isSignedIn) {
          this.router.navigate(['/sign-in']).then();
          return false;
        }
        return true;
      })
    );
  }

}
